export default "__VITE_ASSET__18c42a2e__"